import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import SignaturePad from "react-signature-canvas";
import { RefreshIcon } from "../../../assets/images";
import { setState } from "../../../redux/crudSlice";
import { useAppDispatch } from "../../../store/hooks";
import { MuiBox } from "../boxComponent";
import { MuiStack } from "../stackComponent";
import { systemColor } from "../../../theme/systemColor";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { EUserRole, LOCAL_STORAGE_KEYS } from "../../../constants";
export var SignatureIndex = function (_ref) {
    var setCanvasImage = _ref.setCanvasImage, canvasImage = _ref.canvasImage, isDisabled = _ref.isDisabled, height = _ref.height, SignaturePadwidth = _ref.SignaturePadwidth, onSignatureChange = _ref.onSignatureChange;
    // console.log("canvasImage",canvasImage);
    var dispatch = useAppDispatch();
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var upSM = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var dowMd = useMediaQuery(function (theme) { return theme.breakpoints.down("md"); });
    var IS_TABLET = upSM && dowMd;
    var upXS = useMediaQuery(function (theme) { return theme.breakpoints.up("xs"); });
    var downSM = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_MOBILE = upXS && downSM;
    var _a = useState(null), trimmedDataURL = _a[0], setTrimmedDataURL = _a[1];
    var _b = useState(360), width = _b[0], setWidth = _b[1];
    var signatureAreaWidth = document.getElementById("signatureArea");
    var selectedDesignationStorage = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_DESIGNATION);
    var _c = useState({
        style: isDisabled ? {
            pointerEvents: 'none',
            height: "220px",
            width: '100%'
        } : {
            width: '100%',
            height: "220px"
        }
    }), signProps = _c[0], setSignProps = _c[1];
    useEffect(function () {
        if ((selectedDesignationStorage === null || selectedDesignationStorage === void 0 ? void 0 : selectedDesignationStorage.Name) == EUserRole.FinalInspector) {
            setSignProps(_objectSpread(_objectSpread({}, signProps), {}, {
                width: '100%'
            }));
        }
    }, []);
    var clear = function () {
        dispatch(setState({
            key: "signature",
            value: ""
        }));
        if (canvasImage) {
            setCanvasImage();
        }
        else {
            trimmedDataURL.clear();
            setTrimmedDataURL(null);
        }
    };
    var getSignatureImg = function () {
        if (trimmedDataURL.isEmpty()) {
            return null;
        }
        else {
            dispatch(setState({
                key: "signature",
                value: trimmedDataURL.getTrimmedCanvas().toDataURL("image/png")
            }));
            return trimmedDataURL.getTrimmedCanvas().toDataURL("image/png");
        }
    };
    var onEndSign = function (data) {
        getSignatureImg();
        if (typeof onSignatureChange === 'function') {
            onSignatureChange();
        }
    };
    // useEffect(() => {
    //     // Update the ref when the childFunction changes
    //     childFunctionRef.current = getSignatureImg;
    //     if (trimmedDataURL) {
    //     }
    // }, [trimmedDataURL]);
    return /*#__PURE__*/ React.createElement(MuiBox, {
        sx: {
            width: '100%'
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        width: 'calc(100vw-30px)',
        justifyContent: "flex-end",
        bgcolor: systemColor.white,
        borderRadius: 3
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: "flex-end",
        justifyContent: "flex-end",
        padding: 1,
        width: '100%'
    }, !isDisabled && /*#__PURE__*/ React.createElement("img", {
        id: "refresh-image-icon",
        alt: "refresh",
        src: RefreshIcon,
        onClick: clear,
        style: {
            zIndex: 1,
            height: "24px",
            width: "24px",
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: "flex-end"
        }
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        id: "signatureArea",
        width: width ? SignaturePadwidth : '100%',
        height: height ? height : ''
    }, canvasImage !== "" && canvasImage !== undefined ? /*#__PURE__*/ React.createElement("div", {
        style: {
            height: '220px',
            padding: '8px',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }
    }, /*#__PURE__*/ React.createElement("img", {
        style: {
            maxWidth: "98%",
            maxHeight: '100%'
        },
        src: canvasImage,
        alt: "Screenshot"
    })) : /*#__PURE__*/ React.createElement("div", {
        style: {
            padding: '8px',
            width: '100%'
        }
    }, /*#__PURE__*/ React.createElement(SignaturePad, {
        clearOnResize: false,
        canvasProps: {
            height: height ? height : 220,
            // width: IS_MOBILE ? '320px' : IS_TABLET ? "600px" : '400px',
            style: {
                width: '100%',
                pointerEvents: isDisabled ? 'none' : 'auto'
            }
            // style: isDisabled ? { pointerEvents: 'none' } : {},
        },
        ref: function (data) { return setTrimmedDataURL(data); },
        onEnd: function (data) { return onEndSign(data); }
    })))));
};
